import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import Tooltip from 'components/application/Tooltip';

export default function FormFooter({
  onCancel,
  onSubmit,
  onSubmitTooltip,
  submitButtonDisabled,
  text,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <div className='popup__footer-actions--flex transition-enabled tw-justify-end tw-border-t-grey-200'>
      <TextButton className='tw-mr-3' color='blue' onClick={onCancel} size='md'>
        {i18nTShared('cancel')}
      </TextButton>
      <div className='tooltip-parent'>
        {onSubmitTooltip && (
          <Tooltip
            arrow={true}
            placement='top'
            tooltip={onSubmitTooltip}
            trigger='hover'
          />
        )}
        <FilledButton
          color='mint'
          disabled={submitButtonDisabled}
          onClick={onSubmit}
        >
          {text}
        </FilledButton>
      </div>
    </div>
  );
}

FormFooter.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSubmitTooltip: PropTypes.string,
  submitButtonDisabled: PropTypes.bool,
  text: PropTypes.string.isRequired,
};
